import { styled } from 'styled-components';

export const Content = styled.div`
  width: 600px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;
